// import { SIGNIN_USER_ERROR, SIGNIN_USER_SUCCESS } from '../actionTypes/auth';
import { initURL } from "../actions/common";
import {
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_HIDE_MESSAGE,
  ON_SHOW_MESSAGE,
  INIT_URL,
  SHOW_DIALOG,
  HIDE_DIALOG,
  ON_SHOW_MESSAGE_IMAGE,
  ON_HIDE_MESSAGE_IMAGE,
  CHANGE_THEME,
} from "../actionTypes/common";

const INIT_STATE = {
  loader: false,
  showMessage: false,
  messageStatus: "",
  message: "",
  imageValidation: false,
  initURL: "",
  dialog: false,
  onLine: navigator.onLine,
  theme: localStorage.getItem("theme")
    ? localStorage.getItem("theme")
    : "light",
};

function AuthReducer(state = INIT_STATE, action) {
  const { type, payload } = action;
  console.log({ payload });
  switch (type) {
    case CHANGE_THEME: {
      return { ...state, theme: payload };
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: payload,
      };
    }

    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
        showMessage: false,
      };
    }

    case ON_SHOW_MESSAGE: {
      console.log({ payload }, "ON_SHOW_MESSAGE");
      return {
        ...state,
        loader: false,
        showMessage: true,
        messageStatus: payload.error ? "error" : "success",
        message: payload.userMessage,
      };
    }
    case ON_HIDE_MESSAGE: {
      console.log({ payload });
      return {
        ...state,
        loader: false,
        showMessage: false,
      };
    }
    case ON_SHOW_MESSAGE_IMAGE: {
      console.log({ payload }, "ON_SHOW_MESSAGE");
      return {
        ...state,
        loader: false,
        showMessage: true,
        imageValidation: true,
        messageStatus: payload.error ? "error" : "success",
        message: payload.userMessage,
      };
    }
    case ON_HIDE_MESSAGE_IMAGE: {
      console.log({ payload });
      return {
        ...state,
        loader: false,
        showMessage: false,
        imageValidation: false,
      };
    }
    case SHOW_DIALOG: {
      return {
        ...state,
        dialog: true,
        title: payload.title,
      };
    }

    case HIDE_DIALOG: {
      return {
        ...state,
        loader: false,
        dialog: false,
      };
    }

    default:
      return state;
  }
}

export default AuthReducer;
